/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'

import {
  VerticalTimeline,
  VerticalTimelineElement
} from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />
      <h2>Sechs Jahre Arbeit für die Konzernverantwortungs&shy;initiative</h2>
      <VerticalTimeline animate={false}>
        <VerticalTimelineElement
          className='first milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large blue' />}
        >
          <h3 className='vertical-timeline-element-title'>Mai 2014</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Die Initianten entwickeln ein Grundlagenpapier für eine Initiative «Recht ohne Grenzen»
          </h4>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large blue' />}
        >
          <h3 className='vertical-timeline-element-title'>21. April 2015</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Beginn der Unterschriften&shy;sammlung unter dem Namen «Konzern&shy;verantwortungs&shy;initiative»
          </h4>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large blue' />}
        >
          <h3 className='vertical-timeline-element-title'>Herbst 2015</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Die Initianten legen ein Drehbuch für die Kampagne und «rote Linien» für den Rückzug der Initiative fest
          </h4>

        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large blue' />}
        >
          <h3 className='vertical-timeline-element-title'>10. Oktober 2016</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Einreichung der Volksinitiative mit rund 120'000 Unterschriften, die Initianten lobbyieren für einen Gegenvorschlag des Bundesrates
          </h4>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large blue' />}
        >
          <h3 className='vertical-timeline-element-title'>11. Januar 2017</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Bundesrat beschliesst Ablehnung der Initiative ohne Gegenvorschlag
          </h4>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large blue' />}
        >
          <h3 className='vertical-timeline-element-title'>15. September 2017</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Der Bundesrat schickt die Initiative zur Behandlung an das Parlament
          </h4>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large blue' />}
        >
          <h3 className='vertical-timeline-element-title'>Oktober 2017 – Juni 2019</h3>
          <h4 className='vertical-timeline-element-subtitle'>
          Die Initianten machen politisch Druck, das Parlament lehnt die Initiative ab, ist aber gespalten, ob ein Gegenvorschlag nötig ist
          </h4>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large blue' />}
        >
          <h3 className='vertical-timeline-element-title'>Juni 2019 – Juni 2020</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Seilziehen im Parlament über harten oder weichen Gegenvorschlag
          </h4>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large blue' />}
        >
          <h3 className='vertical-timeline-element-title'>14. August 2019</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Der Bundesrat ist nun plötzlich für einen - allerdings abgeschwächten - Gegenvorschlag
          </h4>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large blue' />}
        >
          <h3 className='vertical-timeline-element-title'>19. Juni 2020</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Parlament sagt Ja zum weichen Gegenvorschlag des Ständerates - den Initianten geht dieser nicht weit genug
          </h4>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className='milestone'
          contentStyle={{ background: 'rgb(255, 255, 255)', color: '#333' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(255, 255, 255)' }}
          iconStyle={{ background: 'rgb(255, 255, 255)', color: '#fff' }}
          icon={<i className='icon dot circle large blue' />}
        >
          <h3 className='vertical-timeline-element-title'>29. November 2020</h3>
          <h4 className='vertical-timeline-element-subtitle'>
            Voraussichtlicher Abstimmungstermin
          </h4>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  )
}
